import { render, staticRenderFns } from "./Download-inbox.vue?vue&type=template&id=eda41d54"
import script from "./Download-inbox.vue?vue&type=script&lang=js"
export * from "./Download-inbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports